import React, { useEffect, useState } from "react";
import { Route, Routes, Navigate } from "react-router-dom";
import Home from "./pages/Home";
import Login from "./pages/Login";
import Logout from "./pages/Logout";
import Register from "./pages/Register";
import Queue from "./pages/Queue";
import { Toaster } from "react-hot-toast";
import SellerVerificationForm from "./pages/SellerVerificationForm";
import { useDispatch, useSelector } from "react-redux";
import { useGetaccessTokenMutation } from "./redux/apislice";
import { setAccessToken } from "./redux/counterSlice";
import ForgotPassword from "./pages/ForgotPassword";
import data from "./base.json";
// Custom Loader Styles
const styles = `
  .loader-container {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
    width: 100vw;
    background: rgba(255, 255, 255, 0.9);
    position: fixed;
    top: 0;
    left: 0;
    z-index: 9999;
  }
  
  .word-loader {
    display: flex;
    align-items: center;
    font-family: 'Arial', sans-serif;
  }
  
  .letter-k {
    font-size: 4.5rem; /* 7xl */
    font-weight: 700;
    color: #3b82f6;
    animation: bounce 0.8s infinite alternate;
  }
  
  .other-letters {
    font-size: 2.5rem; /* 4xl */
    font-weight: 600;
    color: #4b5563;
    opacity: 0;
    animation: fadeIn 0.3s forwards;
  }
  
  @keyframes bounce {
    0% { transform: translateY(0); }
    100% { transform: translateY(-15px); }
  }
  
  @keyframes fadeIn {
    to { opacity: 1; }
  }
  
  /* Individual letter delays */
  .letter-h { animation-delay: 0.1s; }
  .letter-u { animation-delay: 0.2s; }
  .letter-s { animation-delay: 0.3s; }
  .letter-h2 { animation-delay: 0.4s; }
  .letter-a { animation-delay: 0.5s; }
  .letter-l { animation-delay: 0.6s; }
  .letter-l2 { animation-delay: 0.7s; }
  .letter-i { animation-delay: 0.8s; }
`;

function App() {
  const isAuthenticated = useSelector((state) => state.counter.isAuthenticated);
  const [getaccessToken] = useGetaccessTokenMutation();
  const [loader, setLoader] = useState(true);
  const dispatch = useDispatch();
  useEffect(() => {
    const CURRENT_APP_VERSION = "1.0.0"; // Update as needed

    const fetchAccessToken = async () => {
      const storedVersion = localStorage.getItem("appVersion");

      if (storedVersion != data.CURRENT_VERSION) {
        localStorage.clear();
        localStorage.setItem("appVersion", data.CURRENT_VERSION);
      }

      const storedRefreshToken = localStorage.getItem("refreshToken");

      if (storedRefreshToken) {
        try {
          const { value } = JSON.parse(storedRefreshToken);
          if (value) {
            const response = await getaccessToken({
              refreshToken: value,
            }).unwrap();
            if (response?.accessToken) {
              dispatch(setAccessToken(response.accessToken));
            }
          }
        } catch (err) {
          console.error("Error fetching token:", err);
        }
      }
      setLoader(false);
    };

    fetchAccessToken();
  }, [getaccessToken, dispatch]);

  if (loader) {
    return (
      <>
        <style>{styles}</style>
        <div className="loader-container">
          <div className="word-loader">
            <span className="letter-k">K</span>
            <span className="other-letters letter-h">h</span>
            <span className="other-letters letter-u">u</span>
            <span className="other-letters letter-s">s</span>
            <span className="other-letters letter-h2">h</span>
            <span className="other-letters letter-a">a</span>
            <span className="other-letters letter-l">l</span>
            <span className="other-letters letter-l2">l</span>
            <span className="other-letters letter-i">i</span>
          </div>
        </div>
      </>
    );
  }

  return (
    <>
      <Toaster position="top-right" reverseOrder={false} />
      <Routes>
        <Route
          path="/login"
          element={isAuthenticated ? <Navigate to="/" /> : <Login />}
        />

        <Route
          path="/register"
          element={isAuthenticated ? <Navigate to="/" /> : <Register />}
        />
        <Route path="/queue" element={<Queue />} />
        <Route
          path="/*"
          element={isAuthenticated ? <Home /> : <Navigate to="/login" />}
        />
        <Route
          path="/seller-verification"
          element={<SellerVerificationForm />}
        />
        <Route path="/forgot-password" element={<ForgotPassword />} />

        <Route path="*/" element={<Logout />} />
      </Routes>
    </>
  );
}

export default App;
